module.exports = __webpack_public_path__ + "static/media/dk1050y.9db296c3.png";